<template>
  <div
    :class="
      size === 'large' ? $style.gridBackgroundLarge : $style.gridBackgroundSmall
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: 'large' | 'small'
  }>(),
  {
    size: 'large',
  },
)
</script>

<style module>
.gridBackgroundLarge {
  /* Each line is placed at the END of its 5vw block (right edge for vertical,
     bottom edge for horizontal) so the 20th line lands exactly on the card's
     right/bottom edge — no leftover gap before the screen edge. */
  background-color: #24262b;
  background-image:
    linear-gradient(to left, #34373f 1px, transparent 1px),
    linear-gradient(to top, #34373f 1px, transparent 1px);
  background-size: 5vw 5vw;
}

.gridBackgroundSmall {
  /* Each line is placed at the END of its 5% block (right edge for vertical,
     bottom edge for horizontal) so the 20th line lands exactly on the card's
     right/bottom edge — no leftover gap before the screen edge. */
  background-color: #24262b;
  background-image:
    linear-gradient(to left, #34373f 1px, transparent 1px),
    linear-gradient(to top, #34373f 1px, transparent 1px);
  background-size: 5% 5%;
}
</style>
